import createBaseService from "@/api/base-service.ts";
import type { ArticleCategory } from "../../types/article-category";

const articleCategoryService = {
	...createBaseService<ArticleCategory>("/article-categories"),
};

export default articleCategoryService;
